import React from "react";
import "./Hero.scss";

export default function Hero() {
  return (
    <div className="hero" id="hero">
      <div className="hero__overlay">
        <div className="hero__content">
          <h1 className="hero__header">Hello! My Name is Jensen Chan!</h1>
          <h3>
            Full Stack Web Developer
          </h3>
        </div>
      </div>
    </div>
  );
}
